import BaseRequest from './BaseRequest';

class BusinessRequests extends BaseRequest {
  REQUEST_TYPE = 'BUSINESS';

  endpoint = '/api/business';

  /**
   * The detail route takes a slug, not an id -- that is what is in the address
   * bar and in a shared link. Nothing else in the app addresses a listing by id.
   */
  findBySlug({ slug, label = '', onSuccess, onFailure }) {
    return this.apiAction({
      url: `${this.getEndpoint()}/${slug}`,
      onSuccess,
      onFailure,
      label: this.getLabel(label, 'GET'),
    });
  }
}

export default BusinessRequests;
